import { Button, Empty, Typography } from 'antd';
import { SVGLogoLight } from '../../images';
import { useNavigate } from 'react-router';

const NotFound = ({
  description,
  showIcon,
  showButton = true,
}: {
  description?: string;
  showIcon?: boolean;
  showButton?: boolean;
}) => {
  const navigate = useNavigate();
  return (
    <div style={{ padding: '50px 0' }}>
      <Empty
        image={showIcon ? <SVGLogoLight /> : null}
        styles={{ image: { height: 60 } }}
        description={
          <Typography.Text>{description || 'Coming soon!'}</Typography.Text>
        }
      >
        {showButton && (
          <Button type="primary" onClick={() => navigate(-1)}>
            Go Back
          </Button>
        )}
      </Empty>
    </div>
  );
};

export default NotFound;
